import { BrowserRouter, Route, Routes } from "react-router-dom";
import Product from "./product";
import Hotchocolate from "./hotc";
import Rocks from "./rocks";
import ColdCoffee from "./frappe";
import Mocktail from "./mocktail";
import Milkshakes from "./milkshake";
import Contact from "./contact";
import Coffee from "./coffee";
import Footer from "./footer";
import Home from "./home";
import AboutUs from "./about";

function AppCoffee() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="about" element={<AboutUs/>}/> */}
          <Route path="product" element={<Product />} />
          <Route path="contact" element={<Contact />} />
          <Route path="coffee" element={<Coffee />} />
          <Route path="rock" element={<Rocks />} />
          <Route path="frap" element={<ColdCoffee />} />
          <Route path="hotc" element={<Hotchocolate />} />
          <Route path="shake" element={<Milkshakes />} />
          <Route path="mock" element={<Mocktail />} />


        </Routes>
        <Footer/>
      </BrowserRouter>

    </>
  )
}

export default AppCoffee;